import React, { createContext, useContext, useEffect, useState } from "react";
import { loadCms } from "./loadCms";
import { WEBSITE_CONTENT_FALLBACK } from "@/constants/cmsFallback";

/**
 * WebsiteContent — editorial copy for the public pages. Same resilience
 * strategy as SiteSettings: cache + retries + static baseline so the site
 * never renders blank even if the CMS is briefly unavailable.
 */
const WebsiteContentCtx = createContext({ data: null, loading: true, error: null });

export function WebsiteContentProvider({ children }) {
  const [state, setState] = useState({
    data: WEBSITE_CONTENT_FALLBACK,
    loading: true,
    error: null,
    source: "fallback",
  });

  useEffect(() => {
    return loadCms(
      "/api/cms/api/globals/website-content",
      "mts:website-content:v1",
      WEBSITE_CONTENT_FALLBACK,
      setState
    );
  }, []);

  return (
    <WebsiteContentCtx.Provider value={state}>{children}</WebsiteContentCtx.Provider>
  );
}

export function useWebsiteContent() {
  return useContext(WebsiteContentCtx);
}
